module.exports = __webpack_public_path__ + "static/media/pt-BR.7b05b514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/pt-BR.png
// module id = 954
// module chunks = 0